<template>
    <div>
        <v-container justify-start>
            <v-layout
                v-bind="{
                    column: $vuetify.breakpoint.xsOnly,
                    row: $vuetify.breakpoint.smAndUp
                }"
                wrap
                align-content-start
                justify-start
            >
                <v-flex shrink>
                    <div class="title mb-2 mr-2">
                        New Division
                    </div>
                </v-flex>
                <v-divider vertical class="hidden-xs-only mr-2"></v-divider>
                <v-flex align-self-start>
                    <v-breadcrumbs divider=">" style="display:inline; padding-left: 0;">
                        <v-breadcrumbs-item style="" to="/admin" v-bind:exact="exact">Administration</v-breadcrumbs-item>
                        <v-breadcrumbs-item style="" to="/admin/divisions" v-bind:exact="exact">Divisions</v-breadcrumbs-item>
                        <v-breadcrumbs-item style="" to="/admin/divisions/new" v-bind:exact="exact">New Division</v-breadcrumbs-item>
                    </v-breadcrumbs>
                </v-flex>
            </v-layout>
            <v-divider></v-divider>
        </v-container>
        <v-container grid-list-md>
            <v-layout row wrap justify-start>
                <v-flex xs12 sm6>
                    <v-card>
                        <v-card-text>
                            <v-form ref="form" v-model="valid">
                                <v-text-field
                                    name="division"
                                    label="Division"
                                    v-model="division"
                                    v-bind:rules="divisionRules"
                                    required
                                ></v-text-field>
                                <v-select
                                    v-model="seasonId"
                                    v-bind:items="seasons"
                                    label="Season"
                                    v-bind:rules="seasonRules"
                                    required
                                ></v-select>
                                <v-combobox
                                    v-model="selected_teams"
                                    v-bind:items="available_teams"
                                    label="Assign Teams"
                                    multiple
                                    chips
                                ></v-combobox>
                            </v-form>
                        </v-card-text>
                        <v-divider></v-divider>
                        <v-card-actions>
                            <v-btn
                                flat
                                color="primary"
                                v-bind:disabled="!valid"
                                v-on:keyup.enter="submit"
                                v-on:click="submit"
                                data-cy="signinSubmitBtn"
                            >Create Division</v-btn>
                        </v-card-actions>
                    </v-card>
                </v-flex>
            </v-layout>
        </v-container>
    </div>
</template>

<script>

export default {
    name: 'AdminDivisionsNew',
    data() {
        return {
            exact: true,
            valid: false,
            division: '',
            divisionRules: [
                (v) => !!v || 'Division name is required',
                (v) => v.length >= 2 || 'Division must be greater than 2 characters',
            ],
            seasonRules: [
                (v) => !!v || 'Season is required'
            ],
            seasonId: '',
            selected_teams: []
        }
    },
    mounted() {
        if (this.$store.state.currentSeason) {
            this.seasonId = this.$store.state.currentSeason.id
        }
    },
    methods: {
        submit() {
            if (this.$refs.form.validate()) {
                let selected_team_ids = []

                this.selected_teams.forEach((team) => {
                    selected_team_ids.push(team.value)
                })

                this.$store.dispatch('createDivision', {
                    division: this.division,
                    season_id: this.seasonId,
                    selected_team_ids: selected_team_ids
                })
            }
        }
    },
    computed: {
        seasons() {
            return this.$store.state.seasons
                .map((season) => {
                    return { text: season.season, value: season.id }
                })
                .sort((a, b) => {
                    if (a.text > b.text) {
                        return -1
                    } else if (a.text < b.text) {
                        return 1
                    } else {
                        return 0
                    }
                })
        },
        divisions() {
            return this.$store.getters.getDivisionsSortedByName
        },
        available_teams() {
            // Only get teams not already assigned to another division for the selected season.
            let available_teams = []

            let teams = this.$store.getters.getTeamsSortedByName
            let divisions_this_season = this.$store.getters.getDivisionsBySeason(this.seasonId)

            teams.forEach((team) => {
                let team_available = true

                divisions_this_season.forEach((division) => {
                    if (division.selected_team_ids.includes(team.id)) {
                        team_available = false
                    }
                })

                if (team_available) {
                    available_teams.push({ text: team.team, value: team.id })
                }
            })

            return available_teams
        }

    }
}
</script>

<style scoped></style>
